import "./VideoSection.css";
import VideoScreen from "./VideoScreen";

const VideoSection = ((props, ref) => {
  return (
    <section className="VideoSection" >
      <div  className="aboveVideo" >
        <VideoScreen />
      </div>

      {/* <div className="reelSectionMainText">
        <h2 className="color-blue-dark">אחרונות מהסטודיו 2</h2>
        <h5 className="color-blue-dark">קטעים נבחרים בתנועה</h5>
      </div> */}
    </section>
  );
});

export default VideoSection;
